(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["polocom-euro-format"] && !Shopify.designMode) return;
  try {
    (() => {
  const priceSelector = '[class*="price"], [class*="subtotal"], [class*="total"], .money, [data-price]';
  const excluded = 'script, style, textarea, input, select, option, [contenteditable="true"]';
  const euroPrefix = /€[\s\u00a0\u202f]*([−-]?\d+(?:[.,\u00a0\u202f ]\d+)*)/g;
  const normalizeNode = (node) => {
    const parent = node.parentElement;
    if (!parent || parent.closest(excluded) || !parent.closest(priceSelector)) return;
    const oldValue = node.nodeValue;
    if (!oldValue || !oldValue.includes('€')) return;
    const newValue = oldValue.replace(euroPrefix, '$1\u00a0€');
    if (newValue !== oldValue) node.nodeValue = newValue;
  };
  const normalize = (root) => {
    if (root.nodeType === Node.TEXT_NODE) return normalizeNode(root);
    if (root.nodeType !== Node.ELEMENT_NODE || root.matches(excluded)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) normalizeNode(node);
  };
  const start = () => {
    const roots = new Set();
    let scheduled = false;
    const flush = () => {
      scheduled = false;
      roots.forEach((root) => { if (root.isConnected) normalize(root); });
      roots.clear();
    };
    document.querySelectorAll(priceSelector).forEach(normalize);
    const observer = new MutationObserver((records) => {
      for (const record of records) {
        if (record.type === 'characterData') roots.add(record.target);
        else record.addedNodes.forEach((node) => roots.add(node));
      }
      if (roots.size && !scheduled) {
        scheduled = true;
        requestAnimationFrame(flush);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
